import { Component } from '@angular/core';

@Component({
  selector: 'pdf-zoom-out',
  templateUrl: './pdf-zoom-out.component.html',
  styleUrls: ['./pdf-zoom-out.component.css'],
})
export class PdfZoomOutComponent {}
